// extracted by mini-css-extract-plugin
export default {"fabContainer":"SecondaryAppBar_fabContainer__Wsb9s","fabRoot":"SecondaryAppBar_fabRoot__kIyvf"};